import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import ChecklistOutlinedIcon from "@mui/icons-material/ChecklistOutlined";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { DashboardSafeCard } from "./DashboardSafeCard";

const reminderItemSx = {
    borderRadius: "12px",
    px: 1.5,
    py: 1.25,
    mx: -1.5,
    transition: "all 280ms cubic-bezier(0.4, 0, 0.2, 1)",
    background: "transparent",
    "&:hover": {
        background: "rgba(14, 165, 164, 0.05)",
        transform: "translateX(4px)",
        "& .reminder-dot": {
            transform: "scale(1.4)",
            color: "#0d9488",
        },
    },
};

const dotSx = {
    fontSize: 8,
    color: "rgba(14, 165, 164, 0.55)",
    mt: "2px",
    flexShrink: 0,
    transition: "all 280ms cubic-bezier(0.4, 0, 0.2, 1)",
};

const reminderTextSx = {
    fontSize: "0.855rem",
    lineHeight: 1.6,
    letterSpacing: "0.005em",
    color: "#44403c",
};

const chipSx = {
    borderColor: "rgba(13, 148, 136, 0.28)",
    borderRadius: "8px",
    fontWeight: 500,
    letterSpacing: "0.01em",
    backdropFilter: "blur(6px)",
    background: "rgba(14, 165, 164, 0.04)",
    transition: "all 280ms cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
        background: "rgba(14, 165, 164, 0.1)",
        borderColor: "rgba(13, 148, 136, 0.5)",
        transform: "scale(1.04)",
    },
};

export default function DashboardSafeReminders() {
    return (
        <DashboardSafeCard
            icon={<ChecklistOutlinedIcon />}
            title="Rappels essentiels"
            accent="#0ea5a4"
            accentSoft="rgba(14, 165, 164, 0.18)"
            footer={
                <Stack direction="row" spacing={1} sx={{ mt: 2, flexWrap: "wrap" }}>
                    <Chip label="Profil" size="small" variant="outlined" sx={chipSx} />
                    <Chip label="Notifications" size="small" variant="outlined" sx={chipSx} />
                    <Chip label="Missions" size="small" variant="outlined" sx={chipSx} />
                </Stack>
            }
        >
            <Stack spacing={0.5}>
                <Box sx={reminderItemSx}>
                    <Stack direction="row" spacing={1.25} alignItems="flex-start">
                        <FiberManualRecordIcon className="reminder-dot" sx={dotSx} />
                        <Typography variant="body2" sx={reminderTextSx}>
                            Mettez à jour votre profil pour rester joignable (email, téléphone, adresse).
                        </Typography>
                    </Stack>
                </Box>

                <Box sx={reminderItemSx}>
                    <Stack direction="row" spacing={1.25} alignItems="flex-start">
                        <FiberManualRecordIcon className="reminder-dot" sx={dotSx} />
                        <Typography variant="body2" sx={reminderTextSx}>
                            Consultez vos notifications pour ne rien manquer des actualités internes.
                        </Typography>
                    </Stack>
                </Box>

                <Box sx={reminderItemSx}>
                    <Stack direction="row" spacing={1.25} alignItems="flex-start">
                        <FiberManualRecordIcon className="reminder-dot" sx={dotSx} />
                        <Typography variant="body2" sx={reminderTextSx}>
                            Suivez vos missions actives et vos absences déclarées en temps réel.
                        </Typography>
                    </Stack>
                </Box>
            </Stack>
        </DashboardSafeCard>
    );
}
